const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the saml transition Directive which defines the sign in form behavior and markup
 * @argument {Users} Users injected to access the Users resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('samlTransition', ['Application', 'Authorization', 'Analyze', 'AccessHelper', '$translate', 'i18n', function (Application, Authorization, Analyze, AccessHelper, $translate, i18n) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/saml-transition.html'),
    controller: function () {
      if (Application.navigation.getPath() !== '/saml-transition') {
        return;
      }
      var self = this;
      self.loading = true;
      Authorization.signout(true);

      var params = Application.navigation.getUrlParameters();
      if (params.authtoken && params.user && params.ttl && params.createdOn) {
        AccessHelper.manualSessionData()
        .then(function(results) {
          if (!results) {
            return;
          }

          Analyze.record({resource: 'useragents'}, {useragent: Application.userAgent});
          Analyze.record({resource: 'authtokens'}, {token: Authorization.getAuthToken().token, action: 'signin'});
          Application.analyticsProvider.trackEvent('signin');
          var redirect = Application.storage.get('preRedirect');

          // LANGUAGE
          if (Authorization.getAuthToken() && Authorization.getAuthToken().user && Authorization.getAuthToken().user.language) {
            i18n.language(Authorization.getAuthToken().user.language);
          }

          self.loading = false;

          if (redirect) {
            Application.storage.remove('preRedirect');
            Application.navigation.goTo(redirect, {});
            return;
          }

          Application.navigation.goToHome();

        }).catch(function(error) {
          self.loading = false;
          Authorization.clearAuthToken();
          console.log('Error', error);
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCredentials'], duration: 5});
          Application.navigation.goTo('/signin');
        });

        $translate(['modules.notifications.invalidCredentials']).then(function(data){
          self.translations = data;
        });

      }

    },
    controllerAs: 'saml'
  };
}]);
